import React, { useRef } from "react";
import { Bar } from "react-chartjs-2";
import Chart from "chart.js/auto";
import { CategoryScale } from "chart.js";
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Button } from "@mui/material";
import { CSVLink } from "react-csv";
import { useTranslation } from "react-i18next";

import FileDownloadIcon from '@mui/icons-material/FileDownload';

Chart.register(CategoryScale);
Chart.register(ChartDataLabels);
Chart.defaults.color = '#242d49';

const BarChart = ({chartData, labelData, catLabelData, title, xLabel, yLabel, chartName, chartInfo, chartColors}) => {
  let barChartRef = useRef(null)

  const { t } = useTranslation();

  function downloadAsImage(){
    const link = document.createElement('a');
    link.download = (chartName ? title + " - " + chartName + "-Chart.png" : title + "-Chart.png");
    link.href = barChartRef.current.toBase64Image('image/png', 1);
    link.click();
  }

  const backgroundColors = ["#FFB5B5", "#E8CFFA", "#8CCDFF", "#AAEACB", "#E1F886"]

  const chartDataFormat = {
    labels: labelData, 
    // datasets: [
    //   {
    //     label: catLabelData ? catLabelData[0] < 0 ? "Invalid Entries" : "WCPM between 0 - " + catLabelData[0] : "cat1",
    //     data: chartData.map((data) => data[0]/data[5]),
    //     backgroundColor: ["#FFB5B5"],
    //     // borderColor: "black",
    //     // borderWidth: 1
    //   },
    //   {
    //     label: catLabelData ? "WCPM between " + (catLabelData[0]+1) + " - " + catLabelData[1] : "cat2",
    //     data: chartData.map((data) => data[1]/data[5]),
    //     backgroundColor: ["#E8CFFA"],
    //     // borderColor: "black",
    //     // borderWidth: 1
    //   },
    //   {
    //     label: catLabelData ? "WCPM between " + (catLabelData[1]+1) + " - " + catLabelData[2] : "cat3",
    //     data: chartData.map((data) => data[2]/data[5]),
    //     backgroundColor: ["#8CCDFF"],
    //     // borderColor: "black",
    //     // borderWidth: 1
    //   },
    //   {
    //     label: catLabelData ? catLabelData[3] < 0 ?  "WCPM >= " + (catLabelData[2]+1) : "WCPM between " + (catLabelData[2]+1) + " - " + catLabelData[3] : "cat4",
    //     data: chartData.map((data) => data[3]/data[5]),
    //     backgroundColor: ["#AAEACB"],
    //     // borderColor: "black",
    //     // borderWidth: 1
    //   },
    //   {
    //     label: catLabelData ? catLabelData[3] < 0 ? "-" : "WCPM >= " + (catLabelData[3]+1) : "cat5",
    //     data: chartData.map((data) => data[4]/data[5]),
    //     backgroundColor: ["#E1F886"],
    //     // borderColor: "black",
    //     // borderWidth: 1
    //   }
    // ]
    datasets: catLabelData.map((cat, i) => {
      return {
        "label": cat,
        "data": chartData.map((data) => data[i]/data[catLabelData.length]),
        "backgroundColor": chartColors ? chartColors[i] : backgroundColors[i]
      }
    })
    
    // [
    //   {
    //     // label: catLabelData ? catLabelData[0] < 0 ? "Invalid Entries" : "WCPM between 0 - " + catLabelData[0] : "cat1",
    //     label: catLabelData ? catLabelData[0] : "cat1",
    //     data: chartData.map((data) => data[0]/data[5]),
    //     backgroundColor: ["#FFB5B5"],
    //     // borderColor: "black",
    //     // borderWidth: 1
    //   },
    //   {
    //     // label: catLabelData ? "WCPM between " + (catLabelData[0]+1) + " - " + catLabelData[1] : "cat2",
    //     label: catLabelData ? catLabelData[1] : "cat2",
    //     data: chartData.map((data) => data[1]/data[5]),
    //     backgroundColor: ["#E8CFFA"],
    //     // borderColor: "black",
    //     // borderWidth: 1
    //   },
    //   {
    //     // label: catLabelData ? "WCPM between " + (catLabelData[1]+1) + " - " + catLabelData[2] : "cat3",
    //     label: catLabelData ? catLabelData[2] : "cat3",
    //     data: chartData.map((data) => data[2]/data[5]),
    //     backgroundColor: ["#8CCDFF"],
    //     // borderColor: "black",
    //     // borderWidth: 1
    //   },
    //   {
    //     // label: catLabelData ? catLabelData[3] < 0 ?  "WCPM >= " + (catLabelData[2]+1) : "WCPM between " + (catLabelData[2]+1) + " - " + catLabelData[3] : "cat4",
    //     label: catLabelData ? catLabelData[3] : "cat4",
    //     data: chartData.map((data) => data[3]/data[5]),
    //     backgroundColor: ["#AAEACB"],
    //     // borderColor: "black",
    //     // borderWidth: 1
    //   },
    //   {
    //     // label: catLabelData ? catLabelData[3] < 0 ? "-" : "WCPM >= " + (catLabelData[3]+1) : "cat5",
    //     label: catLabelData ? catLabelData[4] : "cat5",
    //     data: chartData.map((data) => data[4]/data[5]),
    //     backgroundColor: ["#E1F886"],
    //     // borderColor: "black",
    //     // borderWidth: 1
    //   }
    // ]
  };

  return (
    <>
      <div style={{display: "flex", justifyContent: "space-between", flexWrap: "wrap"}}>
        <h4 style={{color: "#dc3545"}}>{chartInfo ? chartInfo : null}</h4>
        <div style={{display: "flex", gap: "0.5rem"}}>
          <Button color="info" variant="contained" size="small" onClick={downloadAsImage}>
            {t("commonComponents.barChart.buttonLabel_imgDownload")}
          </Button>
          <Button  color="info" variant="contained" size="small" startIcon={<FileDownloadIcon />} sx={{ placeSelf: "start" }}>
            <CSVLink 
              data={[[xLabel, ...catLabelData, "Total"]].concat(chartData.map((item, i) => [labelData[i], ...item]))} 
              // headers={headers} 
              filename={chartName ? title + " - " + chartName + ".csv" : title + ".csv"}
            >
              {t("commonComponents.barChart.buttonLabel_csvDownload")}
            </CSVLink>
          </Button>
        </div>
      </div>
      <Bar
        ref = {barChartRef}
        data = {chartDataFormat}
        options = {
          {
            interaction: {
              intersect: false,
              mode: 'index',
            },
            plugins: {
              title: {
                display: true,
                text: title,
                font: {
                  family: "Poppins",
                  size: "14px",
                },
              },
              datalabels: {
                color: "black",
                formatter: function (value, context) {
                  if (context.chart.data.datasets[context.datasetIndex] != null) {
                    if (value === 0) return null;
                    return chartData[context.dataIndex][context.datasetIndex]
                  }
                },
                events: [],
              },
              tooltip: {
                callbacks: {
                  label: function (context) {
                    return context.dataset.label + ": " + chartData[context.dataIndex][context.datasetIndex] + " (" + context.formattedValue + ")"
                  },
                  footer: function (tooltipItems) {
                    let total = 0;
                    tooltipItems.forEach(function(tooltipItem) {
                      total += chartData[tooltipItem.dataIndex][tooltipItem.datasetIndex];
                    });
                    return t("commonComponents.barChart.catTotal") + ': ' + total;
                  },
                }
              },
              legend: {
                labels: {
                  font: {
                    family: "Poppins",
                    weight: "bold",
                    // size: "14px",
                  }
                }
              }
            },
            responsive: true,
            maintainAspectRatio: false,
            scales: {
              x: {
                stacked: true,
                title: {
                  display: true,
                  text: xLabel,
                  font: {
                    family: "Poppins",
                    weight: "bolder",
                    size: "14px",
                  },
                },
                ticks: {
                  // maxRotation: 0,   // This controls the rotation of labels
                  font: {
                    family: "Poppins",
                    weight: "bold",
                    // size: "14px",
                  }
                }
              },
              y: {
                max: 1,
                stacked: true,
                title: {
                  display: true,
                  text: yLabel,
                  font: {
                    family: "Poppins",
                    weight: "bolder",
                    size: "14px",
                  },
                },
                ticks: {
                  beginAtZero: true,
                  format: {
                    style: "percent"
                  },
                  font: {
                    family: "Poppins",
                    weight: "bold",
                    // size: "14px",
                  }
                },
              },
            }
          }
        }
      />
    </>
  );
};

export default BarChart;